import { useMutation, useQueryClient } from "react-query";
import { returnIO } from "@/api/Histories/io-api";

export function useIOReturn(listType, filters = null) {
	const queryClient = useQueryClient();

	return useMutation(({ ioIds, action }) => returnIO({ ioIds, action, filters }), {
		onSuccess: (response) => {
			if (response?.updated_data) {
				const { data, total } = response.updated_data;
				queryClient.setQueryData(["histories", "list", listType, filters], (oldData) => {
					if (!oldData) {
						return {
							data,
							total,
							totalRecords: total,
						};
					}

					return {
						...oldData,
						data,
						total,
						totalRecords: total,
					};
				});
			}
		},
	});
}
